const INSTALLED_DISPLAY_MODES = [
  'standalone',
  'minimal-ui',
  'fullscreen',
  'window-controls-overlay',
  'tabbed',
];

// Chrome reports an installed app as any of the non-browser display modes, so a single
// mode check would silently skip warming for part of the installed base.
const isInstalledPwa = () =>
  INSTALLED_DISPLAY_MODES.some((mode) => window.matchMedia(`(display-mode: ${mode})`).matches) ||
  (navigator as Navigator & { standalone?: boolean }).standalone === true;

export const isOfflineWarmingEnabled = () =>
  'caches' in window &&
  'serviceWorker' in navigator &&
  isInstalledPwa() &&
  window.PUBLIC_ENV?.disableNextPrefetchFeature !== 'true';
